const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  let qualificationMenu = document.querySelector('.qualification__index')
  let qualification = document.querySelector('.qualification')
  let header = document.querySelector('.header')
  let sticky = qualificationMenu.offsetTop + header.offsetHeight
  let stickyClass = 'qualification__index--sticky'
  let stuckClass = 'qualification__index--stuck'
  let indexButton = document.querySelector('.qualification__index > button')

  checkMenuPosition()
  checkAnchorPosition()

  window.addEventListener('scroll', function () {
    checkMenuPosition()
    checkAnchorPosition()
  })

  if (indexButton) {
    indexButton.addEventListener('click', function () {
      let expanded = this.getAttribute('aria-expanded')

      if (expanded === 'false') {
        this.setAttribute('aria-expanded', true)
      } else {
        this.setAttribute('aria-expanded', false)
      }
    }, false)

    document.addEventListener('click', function (event) {
      if (event.target !== indexButton) {
        indexButton.setAttribute('aria-expanded', 'false')
      }
    })
  }

  function checkAnchorPosition () {
    const sections = document.querySelectorAll('.qualification > .element')

    sections.forEach(el => {
      let top = el.getBoundingClientRect().top - 100
      let bottom = top + el.clientHeight
      let scroll = document.body.scrollTop
      if (scroll > top && scroll < bottom) {
        let activeAnchor = document.querySelector('.qualification__index a.active')
        let id = el.id
        let IdAnchor = document.querySelector('.qualification__index a[href="#' + id + '"')
        if (activeAnchor) {
          activeAnchor.classList.remove('active')
        }
        if (IdAnchor) {
          IdAnchor.classList.add('active')
        }
      }
    }, false)
  }

  function checkMenuPosition () {
    let headerHeight = header.offsetHeight
    let qualificationHeight = qualification.offsetHeight
    let bottom = qualificationHeight - headerHeight
    let scrollFromTop = window.pageYOffset

    if (scrollFromTop >= sticky) {
      if (scrollFromTop >= bottom) {
        qualificationMenu.classList.add(stuckClass)
        qualificationMenu.classList.remove(stickyClass)
      } else {
        qualificationMenu.classList.add(stickyClass)
        qualificationMenu.classList.remove(stuckClass)
      }
    } else {
      qualificationMenu.classList.remove(stickyClass)
    }
  }
})
